import { makeStyles } from '@mui/styles';
import IconButton from 'apollo-react/components/IconButton';
import ArrowDown from 'apollo-react-icons/ArrowDown';
import ArrowUp from 'apollo-react-icons/ArrowUp';
import Pencil from 'apollo-react-icons/Pencil';
import Trash from 'apollo-react-icons/Trash';
import classNames from 'classnames';
import React from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';

import {
  changeControlPositionByButton,
  deleteControl,
  setSelectedControlObject,
} from '../../../actions/report-designer.actions';
import { MOVE_BUTTON_TYPES } from '../../../constants/report-designer.constants';
import {
  getControlProperty,
  getParentChildrenControlTypes,
  getSelectedControlId,
} from '../../../selectors/report-designer.selectors';
import { getIsMoveBtnDisabled } from '../../../utils/report-designer.utils';

const useStyles = makeStyles({
  root: { display: 'flex' },
  selected: { color: '#fff' },
});

const ActionCell = ({
  row: { controlId, controlType, expandedRowId, setExpandedRowId },
  column: { hasExpandableRow },
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const selectedControlId = useSelector(getSelectedControlId);
  const parentId = useSelector((state) =>
    getControlProperty(state, { id: controlId, prop: 'parentId' })
  );
  const parentChildrenControlTypes = useSelector((state) =>
    getParentChildrenControlTypes(state, { parentId })
  );

  const isControlSelected = controlId === selectedControlId;

  const handleDelete = () => {
    dispatch(deleteControl(controlId, false));
  };

  const handleMoveUp = () => {
    batch(() => {
      !isControlSelected && dispatch(setSelectedControlObject(controlId, false));
      dispatch(changeControlPositionByButton(controlId, MOVE_BUTTON_TYPES.UP));
    });
  };

  const handleMoveDown = () => {
    batch(() => {
      !isControlSelected && dispatch(setSelectedControlObject(controlId, false));
      dispatch(changeControlPositionByButton(controlId, MOVE_BUTTON_TYPES.DOWN));
    });
  };

  const handleEdit = () => {
    setExpandedRowId(controlId === expandedRowId ? null : controlId);
    !isControlSelected && dispatch(setSelectedControlObject(controlId, false));
  };

  return (
    <>
      <div className={classes.root}>
        {hasExpandableRow && (
          <IconButton
            size="medium"
            className={classNames({
              [classes.selected]: isControlSelected,
            })}
            onClick={handleEdit}
          >
            <Pencil />
          </IconButton>
        )}
        <IconButton
          size="medium"
          className={classNames({
            [classes.selected]: isControlSelected,
          })}
          disabled={getIsMoveBtnDisabled(
            controlId,
            controlType,
            parentChildrenControlTypes,
            MOVE_BUTTON_TYPES.UP
          )}
          onClick={handleMoveUp}
        >
          <ArrowUp />
        </IconButton>
        <IconButton
          size="medium"
          className={classNames({
            [classes.selected]: isControlSelected,
          })}
          disabled={getIsMoveBtnDisabled(
            controlId,
            controlType,
            parentChildrenControlTypes,
            MOVE_BUTTON_TYPES.DOWN
          )}
          onClick={handleMoveDown}
        >
          <ArrowDown />
        </IconButton>
        <IconButton
          size="medium"
          className={classNames({
            [classes.selected]: isControlSelected,
          })}
          onClick={handleDelete}
        >
          <Trash />
        </IconButton>
      </div>
    </>
  );
};

export default ActionCell;
